import * as d3 from 'd3';

import BenchlingConfig from 'BenchlingConfig';
import {Part} from 'biojs/Part';
import {
  PART_ANNOTATION_ARCHIVED_COLOR,
  PART_ANNOTATION_ARCHIVED_OPACITY,
  PART_ANNOTATION_COLOR,
  PART_ANNOTATION_OUT_OF_SYNC_COLOR,
} from 'molbio/maps/BiointelligentLinksConstants';
import CircularBiointelligentLinkAnnotationsView from 'molbio/maps/circular/BiointelligentLinkAnnotationsView';
import {NEAR_BLACK, WHITE} from 'ui-library/Colors';

/**
 * View for drawing parts on the plasmid map as annotations when overlapping parts is enabled in addition
 * to rendering part overlays on the axis (See PartsView)
 */
class CircularSequencePartAnnotationsView extends CircularBiointelligentLinkAnnotationsView<Part> {
  singularClassName = 'part-annotation';

  static initClass(): void {
    this.prototype.className = 'part-annotations';
    this.prototype.singularClassName = 'part-annotation';
    this.prototype.tagName = 'g';

    // Need to set contextMenuData to null to default to showing the parts context menu.
    // Should revisit this behavior to match other features.
    // @ts-expect-error
    this.prototype.contextMenuData = null;
  }

  override fill(d: Part): string {
    const outOfSync = !d.isInSync(this.model.polymer()._sequence());
    const isArchived = d.sequence().isArchived();
    if (outOfSync) {
      return PART_ANNOTATION_OUT_OF_SYNC_COLOR;
    } else if (isArchived) {
      return PART_ANNOTATION_ARCHIVED_COLOR;
    } else {
      return PART_ANNOTATION_COLOR;
    }
  }

  override fontColor(d: Part): string {
    return d.sequence().isArchived() ? NEAR_BLACK : WHITE;
  }

  override opacity(d: Part): number {
    return d.sequence().isArchived() ? PART_ANNOTATION_ARCHIVED_OPACITY : super.opacity(d);
  }

  override data(): Array<Part> {
    // Only show part annotations if overlapping parts is enabled, otherwise PartsView already shows labels.
    if (BenchlingConfig.PARTS_ENABLE_OVERLAPPING_PARTS) {
      return this.model
        .get('sequence')
        .parts()
        .getSequencePartsBetween(this.model.get('leftBP'), this.model.get('rightBP'));
    }
    return [];
  }

  clickAction(e: MouseEvent, d: Part): void {
    d.click(this.model.polymer(), e.shiftKey);
  }

  dblClickAction(e: MouseEvent, d: Part): void {
    d.dblClick(this.model.polymer(), e.shiftKey);
  }

  override registerListeners(): void {
    super.registerListeners();
    this.listenTo(this.model.get('sequence').get('_sequence'), 'change:bases', () => {
      this.invalidateData();
    });
  }

  handleDrawContents(selector: d3.Selection<SVGGElement, Part, SVGGElement, unknown>): void {
    // TODO(BNCH-124229)
  }
}
CircularSequencePartAnnotationsView.initClass();

export default CircularSequencePartAnnotationsView;
